import React from 'react';
import Accommodations from "../../components/accommodations/accommodations";
import Banner from "../../components/banner/banner";
import Blog from "../../components/blog/blog";
import Deluxe from "../../components/deluxe/deluxe";
// import Footer from "../../components/footer/footer";
// import HeaderOne from "../../components/header/HeaderOne";
import ScrollToTopButton from "../../components/scroll-to-top/scrollToTop";
import Testimonial from "../../components/testimonial/testimonial";
import Videoarea from "../../components/videoarea/videoarea";


import HeaderOne from "./components/NavBar";
import Hero from './components/Hero'
import Feature from './components/Feature'
import ScreenShot from './components/ScreenShots'
import Grid from './components/Grid'
import SignUpNow from './components/SignUpNow'
import Parent from './components/Parent'
import Footer from "./components/Footer";
import Scroll from './scrollToTop'
import WhoWe from './components/WhoWe.jsx';
import WhoWe2 from './components/WhoWe2.jsx';

const HomePage = () => {
  return (
    <>
    <Scroll/>
      <HeaderOne />
      <Hero />
      <ScreenShot />

      <Feature />
      {/* <Grid /> */}
      <WhoWe/>

      <SignUpNow/>

      <Parent />
      {/* <SignUpNow/> */}

      {/* <Testimonial />
      <Blog /> */}
      <Footer />
      <ScrollToTopButton />
    </>
  );
}

export default HomePage;
